export const signInDefaults = (
  development: boolean,
): { email: string; magicLinkInboxUrl?: string } =>
  development
    ? {
        email: 'dev@life-rpg.local',
        magicLinkInboxUrl: 'http://127.0.0.1:54324',
      }
    : { email: '' };
